// 環境依存文字マッピング定義照会・更新画面の一覧表のラベル
export const LABELS = {
  TITLE: "環境依存文字変換定義",
  DEPENDENCE_CHARACTER: "環境依存文字",
  CONVERTED_CHARACTER: "変換後文字",
  UPLOAD_CONFIIM:
    "アップロード前件数：{0}件\r\nアップロード後件数：{1}件\r\n新規：{2}件\n/\n更新：{3}件\n/\n削除：{4}件",
} as const;

export const CONFIGS = {
  FILE: "file",
  FILE_EXTENTION: ".csv",
  SUCCSESS: "success",
} as const;
